The video to render within the job ad.
